import React from 'react'
import './AuthPages.css'

interface AccessDeniedPageProps {
  onRetry?: () => void
}

const AccessDeniedPage: React.FC<AccessDeniedPageProps> = ({ onRetry }) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry()
    } else {
      window.location.href = '/'
    }
  }

  return (
    <div className="auth-page auth-page--denied">
      <div className="auth-page__bg" />
      <div className="auth-card auth-card--denied">
        <div className="auth-card__icon auth-card__icon--denied" aria-hidden>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>
        <h1 className="auth-card__title">Access denied</h1>
        <p className="auth-card__message">
          You do not have permission to access this application, or the sign-in request was cancelled.
        </p>
        <button type="button" className="auth-card__btn auth-card__btn--primary" onClick={handleRetry}>
          Try again
        </button>
      </div>
    </div>
  )
}

export default AccessDeniedPage
